function checkBackTop () {
    let halfH = $(document).height() / 2
    let footerTop = $('footer').position().top
    let scrollTop = $(window).scrollTop()
    let windowHeight = $(window).height()
    let footerbreakpoint = footerTop - scrollTop

    if (scrollTop >= halfH && !($('#bid-bar').length > 0 && !(footerbreakpoint <= windowHeight))) {
        $('.backtop').show(200)
    } else {
        $('.backtop').hide(200)
    }

    //also decrease nav bar size
    if (scrollTop > 50) $('header .navbar').addClass('scrolled')
    else $('header .navbar').removeClass('scrolled')
}

window.addEventListener('scroll', checkBackTop)
